import Pieces from "./Pieces";

export const InitialGameStateWhite = [
  [
    [
      { colour: Pieces.BLACK_MOAI, value: 1 },
      { colour: Pieces.BLACK_MOAI, value: 1 },
    ],
    [
      { colour: Pieces.BLACK_MOAI, value: 2 },
      { colour: Pieces.BLACK_MOAI, value: 2 },
    ],
    [
      { colour: Pieces.BLACK_MOAI, value: 3 },
      { colour: Pieces.BLACK_MOAI, value: 3 },
    ],
    [
      { colour: Pieces.BLACK_MOAI, value: 4 },
      { colour: Pieces.BLACK_MOAI, value: 4 },
    ],
  ],
  [[], [], [], []],
  [[], [], [], []],
  [[], [], [], []],
  [
    [
      { colour: Pieces.WHITE_MOAI, value: 1 },
      { colour: Pieces.WHITE_MOAI, value: 1 },
    ],
    [
      { colour: Pieces.WHITE_MOAI, value: 2 },
      { colour: Pieces.WHITE_MOAI, value: 2 },
    ],
    [
      { colour: Pieces.WHITE_MOAI, value: 3 },
      { colour: Pieces.WHITE_MOAI, value: 3 },
    ],
    [
      { colour: Pieces.WHITE_MOAI, value: 4 },
      { colour: Pieces.WHITE_MOAI, value: 4 },
    ],
  ],
];
